import {boot} from 'quasar/wrappers'
import Loading from 'quasar/src/plugins/Loading'
import { canRead, isAdmin } from 'src/pages/utils'
import {canSystemAdmin} from 'src/pages/authUtils.js'

export default boot(({app, router, store}) => {
  const whiteList = ['auth-login', 'auth-mfa','auth-forget', 'auth-reissue','auth-reset','auth-email-auth']
  router.beforeEach(async (to, from, next) => {
    if (whiteList.includes(to.name)) {
      // ホワイトリストの場合はスルー
      next()
      return
    }
    const accessToken = localStorage.getItem('auth/ACCESS_TOKEN')
    // const accessToken = store.getters['auth/accessToken']
    if (accessToken) {
      // ログイン済
      Loading.show()
      await store.dispatch('common/setApiClients').catch(() => console.error('APIクライアントの生成に失敗しました。'))
      if (!store.getters['common/isLoaded']) {
        await store.dispatch('common/getData').catch((e) => {
          console.error(`共通データ情報取得に失敗しました。${e}`)
          next({name: 'auth-login'})
        })
      }

      if(to.path.startsWith('/admin')) {
        Loading.hide()
        if(canSystemAdmin(store.state.common.userInfo,store.state.common.userInfo.organization)) {
          next()
        } else {
          next({name: 'error-401'})
        }
      }

      if(to.path.startsWith('/node')) {
        Loading.hide()
        if(store.state.common.nodes.length == 0) {
          next({name: 'error-401'})
        }

        if(to.params.nodeId === "undefined" || to.params.nodeId === "null") {
          const node = store.getters['common/node'](to.params.nodeId)
          to.params.nodeId = node.id
          next({name: to.name, params: to.params})
        }
        Loading.hide()
        // TODO 以下必用か？
        next()
        return
        // if(!canRead(to.params.nodeId, store)) {
        //   next({name: 'error-401'})
        // } else {
        //   next()
        // }
      }

      Loading.hide()
      next()

    } else {
      // 未ログイン
      const routeObj = {
        name: 'auth-login',
        query: {}
      }

      // routesに記載してるかどうか
      if (to.name !== undefined) {
        routeObj.query.redirect = to.path
      }
      next(routeObj)
    }
  })
})
